var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5229 20 20 15.5229 20 10C20 4.47716 15.5229 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5229 4.47716 20 10 20Z",
    fill: "#E24C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99995C20 15.5 15.5 20 9.99998 20C6.81249 20 3.99999 18.5625 2.18747 16.25C3.87497 17.625 6.06248 18.4375 8.43746 18.4375C13.9375 18.4375 18.4375 13.9375 18.4375 8.43748C18.4375 6.06251 17.625 3.875 16.25 2.1875C18.5625 3.99993 20 6.81243 20 9.99995Z",
    fill: "#D1403F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 14.5625C14.1876 14.9375 13.5625 14.9375 13.1875 14.5625L10 11.375L6.81256 14.5625C6.43757 14.9375 5.81254 14.9375 5.43755 14.5625C5.06256 14.1875 5.06256 13.5625 5.43755 13.1875L8.62504 9.99999L5.43755 6.8125C5.06256 6.43751 5.06256 5.81248 5.43755 5.43749C5.81254 5.0625 6.43757 5.0625 6.81256 5.43749L10 8.62498L13.1875 5.43749C13.5625 5.0625 14.1876 5.0625 14.5625 5.43749C14.9375 5.81248 14.9375 6.43751 14.5625 6.8125L11.3751 9.99999L14.5625 13.1875C14.9375 13.5625 14.9375 14.1875 14.5625 14.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelStatus);
export default __webpack_public_path__ + "static/media/cancel-status.9698b6c084d80d6c6d366f99f3136c2e.svg";
export { ForwardRef as ReactComponent };